import { useEffect, useState } from "react";

type Props = {
  open?: (message: string) => void;
};

export type BLEStatus =
  | "REQUEST_START"
  | "REQUEST_STOP"
  | "START_SUCCESS"
  | "START_FAIL"
  | "STOP_SUCCESS"
  | "STOP_FAIL"
  | "DATA_RECEIVE";

export default function useBLEAdvertising({ open }: Props): [
  {
    isLoading: boolean;
    status?: BLEStatus;
  },
  {
    startBLEAdvertisingCall: (data: string) => void;
    stopBLEAdvertisingCall: () => void;
  }
] {
  const defaultUuid = "0000FEAA-0000-1000-8000-00805F9B34FB";
  const [result, setResult] = useState<{
    isLoading: boolean;
    status?: BLEStatus;
  }>({
    isLoading: false,
  });

  const startBLEAdvertisingCall = function (data: string) {
    var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

    if (varUA.indexOf("android") > -1) {
      if (window.SANDI && window.SANDI.showActivity) {
        window.SANDI.startBLEAdvertising(defaultUuid, data);
      } else {
        open?.("BLE 송신 시작에 실패했습니다.");
      }
    } else if (
      varUA.indexOf("iphone") > -1 ||
      varUA.indexOf("ipad") > -1 ||
      varUA.indexOf("ipod") > -1
    ) {
      window.webkit?.messageHandlers.startBLEAdvertising.postMessage({
        uuid: defaultUuid,
        data,
      });
    } else {
      open?.("모바일 기기에서 시도해주세요.");
    }
  };

  const stopBLEAdvertisingCall = function () {
    var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

    if (varUA.indexOf("android") > -1) {
      if (window.SANDI && window.SANDI.showActivity) {
        window.SANDI.stopBLEAdvertising();
        setResult({ isLoading: true, status: "REQUEST_STOP" });
      } else {
        open?.("BLE 송신 중지에 실패했습니다.");
      }
    } else if (
      varUA.indexOf("iphone") > -1 ||
      varUA.indexOf("ipad") > -1 ||
      varUA.indexOf("ipod") > -1
    ) {
      window.webkit?.messageHandlers.stopBLEAdvertising.postMessage(
        "stopBLEAdvertising"
      );
    } else {
      open?.("모바일 기기에서 시도해주세요.");
    }
  };

  const handleStartBLEAdvertising = function (data: boolean) {
    if (data === false) {
      setResult({ isLoading: false, status: "START_FAIL" });
    } else if (data === true) {
      setResult({ isLoading: false, status: "START_SUCCESS" });
    } else {
      open?.(`BLE 송신 시작에 실패했습니다.(data: ${data})`);
    }
  };

  const handleStopBLEAdvertising = function () {
    setResult({ isLoading: false, status: "STOP_SUCCESS" });
  };

  useEffect(() => {
    window.handleStartBLEAdvertising = handleStartBLEAdvertising;
    window.handleStopBLEAdvertising = handleStopBLEAdvertising;
  }, []);

  return [
    result,
    {
      startBLEAdvertisingCall,
      stopBLEAdvertisingCall,
    },
  ];
}
